export default "__VITE_ASSET__Cq3D5SWm__"